"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Slider_st_css_1 = require("./Slider.st.css");
var Ticks = /** @class */ (function (_super) {
    tslib_1.__extends(Ticks, _super);
    function Ticks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Ticks.prototype.calcMaximumTickDensity = function () {
        if (this.props.tickMarksShape === 'line') {
            return 1 / 8;
        }
        return 1 / 16;
    };
    Ticks.prototype.calcStep = function () {
        var _a = this.props, step = _a.step, min = _a.min, max = _a.max, trackSize = _a.trackSize;
        var totalTickCount = (max - min) / Number(step);
        var density = Math.min(totalTickCount / trackSize, this.calcMaximumTickDensity());
        var adjustedStep = (max - min) / (trackSize * density);
        return adjustedStep;
    };
    Ticks.prototype.renderTick = function (i, min, max, vertical, thumbSize) {
        var _a = this.props, tickMarksShape = _a.tickMarksShape, className = _a.className;
        var pct = (i - min) / (max - min);
        var val = "calc(" + pct + " * calc(100% - " + thumbSize + "px) + " + thumbSize /
            2 + "px)";
        return (React.createElement("div", { className: Slider_st_css_1.st(Slider_st_css_1.classes.tick, { tickMarksShape: tickMarksShape }, className), key: i, "data-hook": "tick", onClick: this.props.onTickClick, style: vertical ? { bottom: val } : { left: val } }));
    };
    Ticks.prototype.render = function () {
        var _a = this.props, min = _a.min, max = _a.max, thumbSize = _a.thumbSize, vertical = _a.vertical, trackSize = _a.trackSize;
        if (!trackSize) {
            return null;
        }
        var step = this.calcStep();
        var ticks = [];
        for (var i = min; i < max; i += step) {
            ticks.push(this.renderTick(i, min, max, vertical, thumbSize));
        }
        ticks.push(this.renderTick(max, min, max, vertical, thumbSize));
        return React.createElement("div", { "data-hook": "ticks-wrapper" }, ticks);
    };
    return Ticks;
}(React.PureComponent));
exports.Ticks = Ticks;
//# sourceMappingURL=Ticks.js.map